import React from 'react';
import './SupportCard.css';

/**
 * SupportCard Component
 * Display card for support options with icon
 * Similar to SimpleCard but with icon and optional link
 */
const SupportCard = ({ title, description, icon: Icon, href }) => {
  const content = (
    <div className="support-card">
      {Icon && (
        <div className="support-card-icon">
          <Icon weight="regular" size={20} />
        </div>
      )}
      <h3 className="support-card-title">{title}</h3>
      <p className="support-card-description">{description}</p>
    </div>
  );

  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className="support-card-link">
        {content}
      </a>
    );
  }

  return content;
};

export default SupportCard;
